import { getBackendBaseUrl } from "@/utils/backend-base-url";
import { fetchRequest } from "@/utils/fetching";
import createFetchClient from "openapi-fetch";
import { getCookie } from "typescript-cookie";
import type { paths } from "./schema";

const HeaderToKeyMapper: Record<string, string> = {
	"X-Csrf-Token": "X-Csrf-Token",
};

const customFetch: typeof fetch = async (input, init = {}) => {
	const headers: HeadersInit = new Headers(init.headers || {});

	for (const [headerName, cookieName] of Object.entries(HeaderToKeyMapper)) {
		const cookieValue = getCookie(cookieName);
		if (cookieValue) {
			headers.set(headerName, cookieValue);
		}
	}

	const modifiedInit: RequestInit = {
		...init,
		headers,
	};

	return fetchRequest(new Request(input, modifiedInit));
};

export const fetchClient = createFetchClient<paths>({
	baseUrl: getBackendBaseUrl(),
	mode: import.meta.env.VITE_APP_HEADER_MODE || undefined,
	credentials: import.meta.env.VITE_APP_HEADER_CREDENTIAL || undefined,
	fetch: customFetch,
});

// export const $api = createClient(fetchClient);
